<div class="row">
  <div class="col-lg-12" style="margin-bottom: 5px">
    <button
      i18n="@@Back"
      nbButton
      outline
      status="success"
      type="submit"
      class="back btn ButtonMargins btn-circle btn-xl"
      (click)="Back()"
    >
      <nb-icon icon="arrow-ios-back-outline"></nb-icon>Back to
      {{ PatientShortHandName }}
    </button>
  </div>
</div>

<ng-template #customFinalTutorialContent>
  Hurray! You created your first plan! At this point, feel free to explore the
  plan builder, it’s very easy to use. Simply hit the “Save Plan” button to save
  any changes you are making!
</ng-template>

<div>
  <nb-card [nbSpinner]="showSpinner" nbSpinnerStatus="success" class="PageFormat" #EditView style="min-height: 500px; width: 100%">
    <nb-card-header [hidden]="PlanView">
      <div class="title">
        {{ PlanLabel }} <ngx-how-to-modal [helpLabel]='"How To Create a Meal Plan."'
        [link]='"https://www.youtube.com/embed/MGu0_vQZ7qU"'></ngx-how-to-modal>
      </div>
      <div class="actions">
        <div
          title="Creating New Plans"
          [class.in-tutorial]="inFinalTutorial"
          [class.padding-in-tutorial]="inFinalTutorial"
          [joyrideStep]="TutorialIDs.FinalStep"
          stepPosition="left"
          [stepContent]="customFinalTutorialContent"
        >
          <button
            i18n="@@SavePlan"
            nbButton
            type="submit"
            (click)="onSavePlan()"
            [nbSpinner]="showSpinner"
            
            class="ButtonMargins btn-circle btn-xl btn-main"
            [disabled]="!Valid"
            [hidden]="PlanView || IsViewTemplate"
          >
            Save Plan
          </button>
        </div>
        <ng-template #customDoneTutorialButton></ng-template>

        <ng-template #customNewTutorialContent>
          To save time, let’s load a template from the template database.
        </ng-template>

        <div
          title="Load From Template"
          [class.in-tutorial]="inTutorial"
          [joyrideStep]="TutorialIDs.LoadFromTemplate"
          stepPosition="left"
          [stepContent]="customNewTutorialContent"
        >
          <button
            type="submit"
            nbButton
            (click)="SelectTemplate()"
            
            class="ButtonMargins btn-circle btn-xl btn-alternate"
            [hidden]="PlanView || IsViewTemplate"
          >
            Load Template
          </button>
        </div>
      </div>
    </nb-card-header>

    <nb-card-body [formGroup]="PlanForm" style="padding: 0px !important">
      <div class="FramePadding plan_informations">
     
        <div>
          <div style="width: 100%">
            <ul class="basic_list_informations row">
              <li
                i18n="@@PlanName"
                class="GeneralLabel2 template-name-row col-sm-2"
              >
                Plan Name
              </li>
              <li class="name-editors col-sm-10">
                <smart-edit
                  formControlName="PlanName"
                  [status]="
                    PlanName?.hasError('minlength') ||
                    PlanName?.hasError('maxlength')
                      ? 'danger'
                      : 'primary'
                  "
                  (change)="onNameChange($event)"
                  [MaxLength]="FormConstants.NameMaxLength"
                  i18n-placeholder="@@PlanName"
                  placeholder="Plan Name"
                ></smart-edit>
                <ngx-validation-message
                  i18n-label="@@PlanName"
                  label="Plan Name"
                  [showMaxLength]="PlanName?.hasError('maxlength')"
                  [showRequired]="
                    PlanName?.errors?.required && PlanName?.touched
                  "
                  [maxLength]="FormConstants.NameMaxLength"
                >
                </ngx-validation-message>
              </li>
            </ul>
            <ul class="basic_list_informations row">
              <li
                i18n="@@Description"
                class="GeneralLabel2 template-name-row col-sm-2"
              >
                Description
              </li>
              <li class="name-editors col-sm-10">
                <smart-edit
                  formControlName="PlanDescription"
                  [status]="
                    PlanDescription?.hasError('maxlength')
                      ? 'danger'
                      : 'primary'
                  "
                  [MaxLength]="FormConstants.DescriptionMaxLength"
                  i18n-placeholder="@@Description"
                  placeholder="Description"
                ></smart-edit>
                <ngx-validation-message
                  i18n-label="@@Description"
                  label="Description"
                  [showMaxLength]="PlanName?.hasError('maxlength')"
                  [maxLength]="FormConstants.DescriptionMaxLength"
                >
                </ngx-validation-message>
              </li>
            </ul>
            <ul class="basic_list_informations row">
              <li i18n="@@Description" class="GeneralLabel2 col-sm-2">
                {{ PlanNotesLabel }}
              </li>
              <li class="name-editors col-sm-10">
                <smart-edit
                  formControlName="PlanNotes"
                  i18n-placeholder="@@Notes"
                  placeholder="Notes"
                  [IsMultiLine]="true"
                  [MaxLength]="FormConstants.NotesMaxLength"
                  [(MultiLineHeight)]="PlanNotesHeight"
                >
                </smart-edit>
                <ngx-validation-message
                  i18n-label="@@Notes"
                  label="Notes"
                  [showMaxLength]="PlanNotes?.hasError('maxlength')"
                  [maxLength]="FormConstants.NotesMaxLength"
                >
                </ngx-validation-message>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div [hidden]="PlanView" class="FramePadding">
        <div class="row" #MealContents>
          <div class="col-lg-12">
            <div class="plan_def_buttons">
              <div>
                <section style="float:left; margin-top:4px; padding-right:5px;" [hidden]="PlanView || !CanRemoveDay">
                  <span (click)="OrderUp()" style="cursor: pointer; color:var(--color-primary);">
                    <nb-icon style="font-size: 1.5rem;" icon="arrow-left-outline"></nb-icon>
                  </span>
                  <span (click)="OrderDown()" style="cursor: pointer; color: var(--color-primary);">
                    <nb-icon style="font-size: 1.5rem; cursor: pointer;" icon="arrow-right-outline"></nb-icon>
                  </span>
                </section>
                <button i18n="@@AddNewDay" nbButton   type="submit" (click)="NewDay()"
                  class="btn-circle btn-xl btn-main btn-alternate ButtonMargins" [hidden]="PlanView">
                  Add Day
                </button>
                <button i18n="@@DuplicateDay" nbButton  type="submit" (click)="CopyDay()"
                  class="btn-circle btn-xl btn-main btn-alternate ButtonMargins btn-copy-day" *ngIf="SelectedDayIndex>=0" [hidden]="PlanView">
                  Duplicate Day
                </button>
                <button i18n="@@RemoveDay" nbButton type="submit" (click)="RemoveDay()"
                  class="back btn ButtonMargins btn-remove-day btn-circle btn-xl" [hidden]="PlanView || !CanRemoveDay">
                  <nb-icon icon="trash-2-outline"></nb-icon>
                </button>
              </div>
            </div>

            <div style="min-height: 600px">
              <mat-tab-group
                class="edit-plan-tabs"
                #MealDays
                style="width: 100%"
                [(selectedIndex)]="SelectedDayIndex"
                animationDuration="0ms"
              >
                <mat-tab *ngFor="let day of TheDays; let index = index">
                  <ng-template mat-tab-label>
                    <div>
                      <app-plan-day-label
                        *ngIf="index == SelectedDayIndex"
                        (customfocusout)="onLabelFocusout()"
                        #PlanDayLabel
                        [Day]="day"
                      ></app-plan-day-label>
                      <label
                        class="day-tab-label"
                        *ngIf="index != SelectedDayIndex"
                        >Day {{ getOrderLabel(day.order) }} ({{
                          day.name
                        }})</label
                      >
                    </div>
                    <div style="position:absolute; font-size:8pt; bottom: 2px; font-weight: 300;">{{getDaysOfWeeksString(day)}}</div>
                  </ng-template>

                  <ng-template matTabContent>
                    <app-plan-day-view
                      #PlanDay
                      [Patient]="patient"
                      [Day]="day"
                      [PlanDays]="TheDays"
                      [HidePlanName]="true"
                    >
                    </app-plan-day-view>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>
